module.exports = __webpack_public_path__ + "static/foodboxs@2x-e011daf6995cb6d202f473a9aca20a2f.png";